import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class UniversityOverviewService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_OVERVIEW, data);
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_OVERVIEW(id));
    }

    create(id, data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITY_OVERVIEW(id), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITY_OVERVIEW(id), data);
    }

    createByAdmin(id, data): Observable<any> {
        return this.postRequestWithoutDataDeletion(AppUrl.UNIVERSITY_OVERVIEW(id), data);
    }

    detailByAdmin(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITY_OVERVIEW(id));
    }

    updateByAdmin(id, data): Observable<any> {
        return this.putRequestWithoutDataDeletion(AppUrl.UNIVERSITY_OVERVIEW(id), data);
    }
}
